var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71875 16.1053H3.75C2.37146 16.1053 1.25 14.9839 1.25 13.6053V5.1366C1.25 3.75806 2.37146 2.6366 3.75 2.6366H9.71875C11.0973 2.6366 12.2188 3.75806 12.2188 5.1366V13.6053C12.2188 14.9839 11.0973 16.1053 9.71875 16.1053ZM3.75 3.8866C3.06079 3.8866 2.5 4.44739 2.5 5.1366V13.6053C2.5 14.2946 3.06079 14.8553 3.75 14.8553H9.71875C10.408 14.8553 10.9688 14.2946 10.9688 13.6053V5.1366C10.9688 4.44739 10.408 3.8866 9.71875 3.8866H3.75ZM14.7188 12.0428V2.60535C14.7188 1.22681 13.5973 0.105347 12.2188 0.105347H5.28125C4.93604 0.105347 4.65625 0.385132 4.65625 0.730347C4.65625 1.07556 4.93604 1.35535 5.28125 1.35535H12.2188C12.908 1.35535 13.4688 1.91614 13.4688 2.60535V12.0428C13.4688 12.3881 13.7485 12.6678 14.0938 12.6678C14.439 12.6678 14.7188 12.3881 14.7188 12.0428Z",
    fill: "#8B8CA7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.105347)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6992086a995a593057c219fdd4a22150.svg";
export { ForwardRef as ReactComponent };